var _circle, _line, _circle2, _line2, _circle3, _line3, _circle4, _line4, _circle5, _line5, _circle6, _line6, _circle7, _line7, _circle8, _line8, _circle9, _circle10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDistributionRules(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.94,
    height: 18.94,
    viewBox: "0 0 18.94 18.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.47,
    cy: 9.47,
    r: 3.46,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.47,
    y1: 6.01,
    x2: 9.47,
    y2: 3.04,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.47,
    cy: 1.19,
    r: 0.94,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.47,
    y1: 12.93,
    x2: 9.47,
    y2: 15.9,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.47,
    cy: 17.75,
    r: 0.94,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6.01,
    y1: 9.47,
    x2: 3.04,
    y2: 9.47,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.19,
    cy: 9.47,
    r: 0.94,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 12.93,
    y1: 9.47,
    x2: 15.9,
    y2: 9.47,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.75,
    cy: 9.47,
    r: 0.94,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 7.03,
    y1: 7.03,
    x2: 4.92,
    y2: 4.92,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.61,
    cy: 3.61,
    r: 0.94,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 11.91,
    y1: 11.91,
    x2: 14.02,
    y2: 14.02,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.33,
    cy: 15.33,
    r: 0.94,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 7.03,
    y1: 11.91,
    x2: 4.92,
    y2: 14.02,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.61,
    cy: 15.33,
    r: 0.94,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 11.91,
    y1: 7.03,
    x2: 14.02,
    y2: 4.92,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.33,
    cy: 3.61,
    r: 0.94,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.47,
    cy: 9.47,
    r: 1.61,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributionRules);
export default __webpack_public_path__ + "static/media/distribution-rules.50c68e7135531eee7a7b9e6585736c3c.svg";
export { ForwardRef as ReactComponent };